import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, Effect, ofType, ROOT_EFFECTS_INIT } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, take, tap } from 'rxjs/operators';
import { BcitiEnvironment } from 'src/app/interfaces/store/store.interface';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { AppService } from 'src/app/utils/services/app.service';
import { State } from '..';
import { GetOrganisationsAction, GetOrganisationsErrorAction, GetOrganisationsSucessAction, SetEnvironmentAction, SetOrganisationsAction } from './global.actions';

@Injectable()
export class GlobalEffects {
    constructor(private store: Store<State>, private actions$: Actions, private appService: AppService, private organisationService: OrganisationService, @Inject('Window') private window: Window) {}

    initEnv$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ROOT_EFFECTS_INIT),
            map(() => {
                let environment: BcitiEnvironment;
                try {
                    environment = JSON.parse(this.window.localStorage.getItem('cerberus-env'));
                } catch {
                    console.error('Error reading Cerberus JSON');
                    this.appService.logout();
                }

                if (environment?.label && environment?.baseUrl) {
                    return [SetEnvironmentAction({ environment })];
                }
                this.appService.logout();
                return [];
            }),
            switchMap((actions) => actions),
        );
    });

    initOrgs$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ROOT_EFFECTS_INIT),
            map(() => [GetOrganisationsAction()]),
            switchMap((actions) => actions),
        );
    });

    setEnv$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(SetEnvironmentAction),
            tap(({ environment }) => {
                this.window.localStorage.setItem('cerberus-env', JSON.stringify(environment));
            }),
            switchMap((actions) => []),
        );
    });

    getOrgs$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(GetOrganisationsAction),
            switchMap(() =>
                this.organisationService.getOrganisations().pipe(
                    take(1),
                    map((organisations) => [SetOrganisationsAction({ organisations }), GetOrganisationsSucessAction()]),
                    catchError((error) => of([GetOrganisationsErrorAction(error)])),
                ),
            ),
            switchMap((actions) => actions),
        );
    });
}
